/**
 * FacilityContent
 * 
 * @Author: Focci
 * @Date: 2023-07-18 16:41:47
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-18 16:41:47
 */

import PropTypes from 'prop-types'
import SVGStarSquare from '@img/star-square.svg'
import { Rating } from '@comp/material'
import Link from 'next/link'

export default function FacilityContent({
  data = {}
}) {
  return (
    <Link 
      href={`https://www.google.com/maps/place/?q=place_id:${data.place_id}`}
      target="_blank"
    >
      <div className="px-3 py-3 max-w-60">
        <div className="text-f.8 font-medium">{data.name}</div>
        <div>{data.vicinity}</div>
        <div className="mt-2">
          <Rating
            readOnly
            defaultValue={data.rating} 
            max={5}
            icon={<SVGStarSquare fontSize="inherit" />}
            emptyIcon={<SVGStarSquare fontSize="inherit" />}
          />
        </div>
      </div>
    </Link>
  )
}

FacilityContent.propTypes = {
  data: PropTypes.object,
}
